import styled from "styled-components";

export const LoanCalculatorWrapper = styled.div`
  // background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
  padding: 2rem;

  .container {
    max-width: 1400px;
    margin: 0 auto;
  }

  .header {
    text-align: center;
    margin-bottom: 3rem;

    h1 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #0A1620;
      margin-bottom: 0.5rem;

      span {
        color: #2D5F7A;
        position: relative;
        
        &::after {
          content: '';
          position: absolute;
          bottom: 5px;
          left: 0;
          width: 100%;
          height: 8px;
          background: rgba(45, 95, 122, 0.2);
          z-index: -1;
          border-radius: 4px;
        }
      }
    }

    p {
      font-size: 1.1rem;
      color: #64748B;
    }
  }

  .content-grid {
    display: grid;
    grid-template-columns: 1fr 1.3fr;
    gap: 2rem;

    @media (max-width: 968px) {
      grid-template-columns: 1fr;
    }
  }

  /* Info Section */
  .info-section {
    .info-card {
      background: linear-gradient(135deg, #1A2F3A 0%, #0F2128 100%);
      border-radius: 24px;
      padding: 2rem;
      color: white;
      height: 100%;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      border: 1px solid rgba(123, 196, 224, 0.2);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle, rgba(123, 196, 224, 0.1) 0%, transparent 70%);
        animation: rotate 20s linear infinite;
      }

      @keyframes rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .info-badge {
        display: inline-block;
        background: rgba(123, 196, 224, 0.2);
        color: #7BC4E0;
        padding: 0.25rem 1rem;
        border-radius: 30px;
        font-size: 0.85rem;
        font-weight: 600;
        margin-bottom: 1.5rem;
        border: 1px solid rgba(123, 196, 224, 0.3);
      }

      h3 {
        font-size: 1.8rem;
        font-weight: 600;
        margin-bottom: 1rem;
        color: white;
      }

      .info-description {
        font-size: 1rem;
        line-height: 1.6;
        color: #CCE6F5;
        margin-bottom: 2rem;
      }

      .info-stats {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        margin-bottom: 2rem;

        .stat-item {
          background: rgba(255, 255, 255, 0.05);
          padding: 1rem;
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);

          .stat-label {
            display: block;
            font-size: 0.75rem;
            color: #8FAFC7;
            margin-bottom: 0.5rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .stat-value {
            display: block;
            font-size: 1.25rem;
            font-weight: 700;
            color: #7BC4E0;
          }
        }
      }

      .info-footer {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin-top: 1rem;

        .feature {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.05);
          padding: 0.5rem 1rem;
          border-radius: 30px;
          border: 1px solid rgba(255, 255, 255, 0.1);

          .feature-icon {
            color: #7BC4E0;
            font-weight: bold;
          }

          span:last-child {
            font-size: 0.85rem;
            color: #CCE6F5;
          }
        }
      }
    }
  }

  /* Calculator Section */
  .calculator-section {
    .calculator-card {
      background: white;
      border-radius: 24px;
      padding: 2rem;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
      border: 1px solid #E2E8F0;

      .card-header {
        margin-bottom: 2rem;

        h2 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0A1620;
          margin-bottom: 0.25rem;
        }

        p {
          font-size: 0.9rem;
          color: #64748B;
        }
      }
    }

    .input-group {
      margin-bottom: 2rem;

      label {
        display: block;
        font-size: 0.9rem;
        font-weight: 600;
        color: #1E293B;
        margin-bottom: 0.75rem;

        .required {
          color: #7BC4E0;
          margin-left: 4px;
        }
      }

      .label-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.75rem;

        .value-chip {
          background: linear-gradient(135deg, #F1F5F9 0%, #E2E8F0 100%);
          padding: 0.4rem 1rem;
          border-radius: 30px;
          border: 1px solid #CBD5E0;

          .currency {
            color: #2D5F7A;
            font-weight: 600;
            margin-right: 2px;
          }

          .amount {
            font-weight: 700;
            color: #0A1620;
          }

          .unit {
            color: #64748B;
            margin-left: 4px;
            font-size: 0.85rem;
          }
        }
      }

      .range-labels {
        display: flex;
        justify-content: space-between;
        margin-top: 0.5rem;
        font-size: 0.8rem;
        color: #64748B;
      }
    }

    .loan-purpose-select {
      width: 100%;
      padding: 0.75rem 1rem;
      border: 2px solid #E2E8F0;
      border-radius: 12px;
      font-size: 0.95rem;
      color: #1E293B;
      transition: all 0.3s ease;
      background: white;

      &:focus {
        outline: none;
        border-color: #7BC4E0;
        box-shadow: 0 0 0 3px rgba(123, 196, 224, 0.1);
      }
    }

    .summary-cards {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      margin: 2rem 0 1rem;

      .summary-card {
        background: #F8FAFC;
        border-radius: 16px;
        padding: 1.25rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        border: 1px solid #E2E8F0;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          border-color: #7BC4E0;
          box-shadow: 0 10px 25px rgba(45, 95, 122, 0.1);
        }

        &.principal-card {
          .card-icon {
            background: rgba(45, 95, 122, 0.1);
          }
        }

        &.total-card {
          .card-icon {
            background: rgba(123, 196, 224, 0.1);
          }
        }

        .card-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 24px;
            height: 24px;
          }
        }

        .card-details {
          display: flex;
          flex-direction: column;

          .card-label {
            font-size: 0.7rem;
            color: #64748B;
            margin-bottom: 4px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .card-value {
            font-size: 1.1rem;
            font-weight: 700;
            color: #0A1620;
          }
        }
      }
    }

    .interest-summary {
      background: #F8FAFC;
      border-radius: 12px;
      padding: 1rem;
      margin-bottom: 1.5rem;
      border: 1px dashed #CBD5E0;

      .interest-item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span:first-child {
          color: #64748B;
          font-size: 0.9rem;
        }

        .interest-value {
          font-weight: 700;
          color: #2D5F7A;
          font-size: 1.1rem;
        }
      }
    }

    .action-buttons {
      .accept-button {
        width: 100%;
        background: linear-gradient(135deg, #2D5F7A 0%, #1E3B4A 100%);
        color: white;
        border: none;
        padding: 1rem;
        border-radius: 12px;
        font-weight: 600;
        font-size: 1rem;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid rgba(123, 196, 224, 0.3);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(45, 95, 122, 0.3);
          border-color: #7BC4E0;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
      }
    }

    .terms-note {
      text-align: center;
      margin-top: 1rem;
      font-size: 0.8rem;
      color: #64748B;

      a {
        color: #2D5F7A;
        text-decoration: none;
        font-weight: 600;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  /* Responsive */
  @media (max-width: 768px) {
    padding: 0rem;

    .header h1 {
      font-size: 2rem;
    }

    .info-section .info-card {
      padding: 1.5rem;

      h3 {
        font-size: 1.5rem;
      }

      .info-stats {
        grid-template-columns: 1fr;
      }

      .info-footer {
        flex-direction: column;
      }
    }

    .calculator-section .calculator-card {
      padding: 1.5rem;
    }

    .summary-cards {
      grid-template-columns: 1fr;
    }
  }
`;